import { type ReactNode, useMemo } from "react";
import { createRoot } from "@/shared/lib/componentHierarchy";
import {
  createInlinePlaybackMediator,
  isInlinePlaybackEvent,
} from "@/shared/lib/inlinePlaybackMediator";
import { ComponentHierarchyContext } from "@/shared/ui/component-hierarchy/context";
import { useHierarchyLifetime } from "@/shared/ui/component-hierarchy/hooks";
import { InlinePlaybackContext } from "@/shared/ui/component-hierarchy/inlinePlaybackContext";

export function ComponentRoot({
  children,
}: {
  children: ReactNode;
}): React.ReactElement {
  const playback = useMemo(() => createInlinePlaybackMediator(), []);
  const node = useMemo(() => {
    const root = createRoot();
    root.subscribe((event) => {
      if (!isInlinePlaybackEvent(event)) return "unhandled";
      return playback.dispatch(event).status === "handled"
        ? "handled"
        : "unhandled";
    });
    return root;
  }, [playback]);
  useHierarchyLifetime(playback);
  useHierarchyLifetime(node);
  return (
    <ComponentHierarchyContext.Provider value={node}>
      <InlinePlaybackContext.Provider value={playback}>
        {children}
      </InlinePlaybackContext.Provider>
    </ComponentHierarchyContext.Provider>
  );
}
